import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const LoadingScreen: () => JSX.Element = () => {
  return (
    <div
      data-testid="loading-screen"
      className="h-full mx-auto text-center mt-[20%] mx-6"
    >
      <p className="font-ubuntu text-5xl text-[#015294] mb-6">Total Leave</p>
      <div className="max-w-[400px] mx-auto">
        <LinearProgress />
      </div>
    </div>
  );
};

export default LoadingScreen;
